import script from "./OidoCountrySelector.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoCountrySelector.vue?vue&type=script&setup=true&lang=js"

import "./OidoCountrySelector.vue?vue&type=style&index=0&id=5e4987e0&scoped=true&lang=css"
import "./OidoCountrySelector.vue?vue&type=style&index=1&id=5e4987e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e4987e0"]])

export default __exports__